module.exports = __webpack_public_path__ + "static/media/accounting&finance.4b2e3c04.svg";